import { render, staticRenderFns } from "./introduce.vue?vue&type=template&id=509f9aab&scoped=true&"
import script from "./introduce.vue?vue&type=script&lang=ts&"
export * from "./introduce.vue?vue&type=script&lang=ts&"
import style0 from "./introduce.vue?vue&type=style&index=0&id=509f9aab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f9aab",
  null
  
)

export default component.exports